import useGetCustomerProfileColors from './useGetCustomerProfileColors'

export default useGetCustomerProfileColors
